import { isJSON } from "@/util/utils";

/** 与上传上限、小程序报告 img1～img8 解析对齐 */
const SLOT_KEYS = ["img1", "img2", "img3", "img4", "img5", "img6", "img7", "img8"];

export function normalizeUploadedImageUrl(path) {
  if (!path || typeof path !== "string") return "";
  const p = path.trim();
  if (/^https?:\/\//i.test(p)) return p;
  const base = "https://hzshixiang.site";
  return p.startsWith("/") ? base + p : `${base}/${p}`;
}

export function parseRealPictureUrls(raw) {
  if (raw == null || raw === "") return [];

  let parsed = raw;
  if (typeof raw === "string") {
    if (!isJSON(raw)) return [];
    parsed = JSON.parse(raw);
  }

  if (Array.isArray(parsed)) {
    return parsed.map((v) => (v != null ? String(v).trim() : "")).filter(Boolean);
  }

  if (typeof parsed === "object") {
    if (Array.isArray(parsed.urls) && parsed.urls.length) {
      return parsed.urls.map((v) => (v != null ? String(v).trim() : "")).filter(Boolean);
    }
    const ordered = SLOT_KEYS.map((k) => parsed[k]).filter(Boolean);
    if (ordered.length) return ordered.map(String);
    return Object.values(parsed)
      .map((v) => (v != null ? String(v).trim() : ""))
      .filter(Boolean);
  }

  return [];
}

/**
 * 旧 PDF/截图模板用：按 img1～img8 槽位取图（兼容历史四宫格）。
 * 出具落库请直接 JSON.stringify(url数组)，勿再经此函数截断。
 */
export function realPictureUrlsToSlots(urls) {
  const list = (Array.isArray(urls) ? urls : parseRealPictureUrls(urls))
    .map((v) => (v != null ? String(v).trim() : ""))
    .filter(Boolean)
    .slice(0, SLOT_KEYS.length);
  const slots = {};
  SLOT_KEYS.forEach((k, i) => {
    slots[k] = list[i] || "";
  });
  return slots;
}

/** 报告生成加载图片：与 atlas 等字段一致，去掉域名前缀供 getImgBase64Fn 使用 */
export function realPicturePathForReportLoad(path) {
  if (!path) return "";
  const normalized = normalizeUploadedImageUrl(String(path).trim());
  return normalized.replace("https://hzshixiang.site", "");
}



// WEBPACK FOOTER //
// ./src/util/orderRealPicture.js